/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Cost breakdown by service with percentage
 */
export interface CloudCostMgmtCostByService { 
    /**
     * AWS service name
     */
    service: string;
    /**
     * Cost in USD
     */
    cost: number;
    /**
     * Percentage of total cost
     */
    percent: number;
}

